import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getMessaging } from 'firebase/messaging';

// Firebase config from env (see .env.example and README). Fallbacks allow running without .env.
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
};
const app = initializeApp(firebaseConfig);

let firestore;
if (typeof window !== 'undefined') {
    try {
        firestore = initializeFirestore(app, {
          localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
        });
    } catch (err) {
        if (err.code === 'failed-precondition' || err.code === 'unimplemented') {
            console.warn(
              '[Firestore] Persistent cache unavailable (e.g. private browsing or multiple tabs). Offline cache disabled.',
              err.message
            );
            firestore = getFirestore(app);
        } else {
            throw err;
        }
    }
} else {
    firestore = getFirestore(app);
}

const auth = getAuth();

/** FCM only in browser (getMessaging requires window). */
const messaging = typeof window !== 'undefined' ? getMessaging(app) : null;

export { app, auth, firestore, messaging }